import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../widgets/form/InputTextSF'
import InputSelectUI from '../../../widgets/form/InputSelectUI'

const ClientTxnCategoryCreateModalUI = ({context, successMsg, errorList, setErrorList,
    // keywords
    keywords, onKeywordsChange, keywordsError, setKeywordsError,
    // category
    category, categoryList, onCategoryChange, categoryError, setCategoryError,
    // modes
    createMode, submitted,
    // event handlers
    onSubmit, onCancelClick,
  }) =>
  <ModalFormUI
    context={context}
    titleLabel='Add keywords'
    buttonLabel='Add'
    cancelLabel='Cancel'
    isOpen={createMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <InputTextSF type='text' name='keywords' label='Keywords' maxLength={100}
      value={keywords} onChange={onKeywordsChange}
      error={keywordsError} setError={setKeywordsError}
      autoFocus={true} help='Add comma-separate keywords'
    />
    <InputSelectUI name='category' label='Category' value={category}
      optionList={categoryList}
      onChange={onCategoryChange} error={categoryError}
    />
  </ModalFormUI>

export default ClientTxnCategoryCreateModalUI
